import { styled } from "@linaria/react"

import { CodeSnippet } from "@/components/CodeSnippet/CodeSnippet.tsx"
import { Tooltip } from "@/components/Tooltip/Tooltip.tsx"
import { CopyRegular, Icon16 } from "@/icons/Icons.ts"
import { copyToClipboard } from "@/lib/std.ts"

import type { Property } from "csstype"

type CopyableCodeSnippetProps = {
  text: string
  language?: string
  backgroundColor?: Property.BackgroundColor
}

export const CopyableCodeSnippet = (props: CopyableCodeSnippetProps) => {
  return (
    <Container background={props.backgroundColor}>
      <CopyIconContainer onClick={() => copyToClipboard(props.text)}>
        <Tooltip content="Copy to clipboard" align="end">
          <CopyRegular className={Icon16} />
        </Tooltip>
      </CopyIconContainer>
      <CodeSnippet text={props.text} language={props.language || "sh"} />
    </Container>
  )
}

const Container = styled.div<{ background?: Property.BackgroundColor }>`
  position: relative;

  align-self: stretch;
  overflow-x: auto;

  background: ${props => props.background || "var(--background-color)"};
  border-radius: var(--border-radius-12);
  padding: 12px;

  &::after {
    content: "";
    display: block;
    clear: both;
  }
`

const CopyIconContainer = styled.div`
  float: right;
  margin-left: 8px;
  margin-bottom: 4px;

  cursor: pointer;
  color: var(--text-color-60);

  &:hover {
    color: var(--text-color);
  }
`